import {
  ContentSize,
  ContentTypeEnum,
  type Content,
} from '../../../shared/types'
import { CopyContainerProps } from '../../common/copy/CopyContainer/CopyContainer'
import type { parentMeta } from './type'

import {
  HtmlContent,
  ImagesContent,
  PuzzleContent,
  VideosContent,
  PhoneContent,
  SubwayContent,
  InspectorContent
} from './types'

interface RenderContentProps {
  content: Content
  filePath?: string
  parentMeta?: parentMeta
  index?: number
  size?: ContentSize
  copyContainerStyles?: CopyContainerProps
}

export function renderContent(props: RenderContentProps): JSX.Element {
  const { content, filePath, parentMeta, index, size, copyContainerStyles } =
    props

  switch (content.type) {
    case ContentTypeEnum.Html:
      return (
        <HtmlContent
          key={index}
          parentMeta={parentMeta}
          content={content}
          size={size}
          copyContainerStyles={copyContainerStyles}
        />
      )
    case ContentTypeEnum.Images:
      return (
        <ImagesContent
          key={index}
          parentMeta={parentMeta}
          content={content}
          filePath={filePath}
          size={size}
        />
      )
    case ContentTypeEnum.Video:
      return (
        <VideosContent
          key={index}
          parentMeta={parentMeta}
          content={content}
          filePath={filePath}
          size={size}
        />
      )
    case ContentTypeEnum.Puzzle:
      return (
        <PuzzleContent
          key={index}
          parentMeta={parentMeta}
          content={content}
          filePath={filePath}
        />
      )
    case ContentTypeEnum.Inspector:
      return (
        <InspectorContent
          key={index}
          parentMeta={parentMeta}
          content={content}
          filePath={filePath}
        />
      )
    case ContentTypeEnum.Phone:
      return (
        <PhoneContent
          key={index}
          parentMeta={parentMeta}
          content={content}
          filePath={filePath}
        />
      )
    case ContentTypeEnum.Subway:
      return (
        <SubwayContent
          key={index}
          parentMeta={parentMeta}
          content={content}
          filePath={filePath}
        />
      )
    default:
      return (
        <div className="status-message warning" key={index}>
          Unsupported content type: {content.type}
        </div>
      )
  }
}
